<template>
	<v-row>
		<v-col>

			<div
					class="align-center d-flex mb-8 flex-column"
					style="margin-top: calc(-2rem - 1px)"
			>
				<div :class="[
							'lighten-1',
							'p-absolute',
							'warning',
							'w-100',
							'z-1'
						]"
						 style="height: 1px;"
				></div>
				<div :class="[
							'font-weight-bold',
							'px-2',
							'rounded-bl',
							'rounded-br',
							'text-caption',
							'warning',
							'white--text'
						]"
				>Development
				</div>
			</div>

			<template v-if="section === 'index'">Show the main dashboard here.</template>

			<template v-if="section === 'name'">
				<ui-box>
					<!-- Name -->
					<div class="align-center d-flex justify-space-between">
						<h5>Basic Info</h5>
						<v-btn
								color="secondary"
								depressed
								fab
								small
								:href="`/partner-portal/${partner.id}/passes/${pass.id}/name`"
						>
							<v-icon>
								mdi-pencil-outline
							</v-icon>
						</v-btn>
					</div>
					<v-divider class="mb-8 mt-4 opacity-80"></v-divider>

					<div class="mb-8 mt-n4 text-body-2">
						You may edit the basic details of your pass until your pass launches.
					</div>

					<v-row class="mb-0">
						<v-col class="text-body-2">

							<v-data-table
									hide-default-footer
									hide-default-header
							>
								<template v-slot:body>
									<tr>
										<td class="font-weight-bold table-label">Name</td>
										<td class="table-info">
											{{ pass.name }}
										</td>
									</tr>
									<tr>
										<td class="font-weight-bold table-label">Description</td>
										<td
												class="table-info"
												:class="{
														'font-italic': !pass.description,
														'grey--text': !pass.description
												}"
										>
											{{
												pass.description || 'Oops! Looks like you need to add a description.'
											}}
										</td>
									</tr>
									<tr>
										<td class="font-weight-bold table-label">Launch Date</td>
										<td class="table-info">
											{{ moment(pass.launch_date).format('dddd, MMMMDo YYYY @ hh:mm a') }}
											<div class="text-caption">
												<a href="#">+ Google Calendar</a> | <a href="#">+ Apple
												Calendar</a>
											</div>
										</td>
									</tr>
									<!-- Add more rows as needed -->
								</template>
							</v-data-table>

						</v-col>
						<v-col cols="auto">
							<ui-box
									background-color="rgba(0,0,0,0.02)"
									no-border
									style="max-width: 300px;"
							>
								<span class="text-body-2">
									Helpful Information
								</span>
								<v-divider class="my-1 opacity-30"></v-divider>
								<span class="text-caption">
									Here we can put any helpful information for this section.
								</span>
							</ui-box>
						</v-col>
					</v-row>
				</ui-box>
			</template>

			<template v-if="section === 'places'">
				<ui-box
						:border-color="places.length ? '#e5e5e5' : 'rgba(130, 186, 12, 0.99)'"
				>
					<!-- Places -->
					<div class="align-center d-flex justify-space-between">
						<h5 :class="{ 'primary--text text--darken-2': !places.length }">Places To
							Go</h5>
						<v-btn
								v-if="places.length"
								color="secondary"
								depressed
								fab
								small
								:href="`/partner-portal/${partner.id}/passes/${pass.id}/places`"
						>
							<v-icon>
								mdi-pencil-outline
							</v-icon>
						</v-btn>
					</div>
					<v-divider class="mb-8 mt-4 opacity-80"></v-divider>

					<template v-if="localPlaces.length">

						<div class="mb-8 mt-n4 text-body-2">
							If you have any Places To Go that require an invite you can manage that in
							the Invites section below, or <a href="#">click here</a>.
						</div>

						<v-row class="mb-0">
							<v-col class="text-body-2">

								<bw-table
										aria-label="data-table"
										:headers="placesHeaders"
										hide-default-header
										hide-row-select
										hide-search
										:items="localPlaces"
										:options="{
											itemsPerPage: 5
										}"
								>
									<template v-slot:item.media="{ item }">
										<td style="width: 1%; vertical-align: top;">
											<v-img
													contain
													class="rounded"
													:key="(item.media && item.media[0].id) || defaultMedia.id"
													lazy-src="https://placehold.co/640x320?text=Loading"
													max-width="120"
													:src="(item.media && item.media[0].url) || defaultMedia.url"
													:width="$vuetify.breakpoint.smAndUp ? '10vw' : '20vw'"
											></v-img>
										</td>
									</template>
									<template v-slot:item.name="{ item }">
										<div class="text-subtitle-2">
											{{ item.name }}
										</div>
										<div class="grey--text mb-2 text-body-2 text--darken-1">
											{{ item.formatted_address }}
										</div>
										<div>

											<v-chip
													v-for="(type, index) in item.types"
													:key="`${type.split('_').join(' ')}-${index}`"
													class="me-1 mt-1"
													color="accent lighten-5"
													label
													light
													x-small
											>
												<span class="accent--text text--darken-22">
													{{ type.split('_').join(' ') }}
												</span>
											</v-chip>

										</div>
									</template>
								</bw-table>

							</v-col>
							<v-col cols="auto">
								<ui-box
										background-color="rgba(0,0,0,0.02)"
										no-border
										style="max-width: 300px;"
								>
								<span class="text-body-2">
									Helpful Information
								</span>
									<v-divider class="my-1 opacity-30"></v-divider>
									<span class="text-caption">
									Here we can put any helpful information for this section.
								</span>
								</ui-box>
							</v-col>
						</v-row>
					</template>

					<template v-else>
						Some info and button to go add places.
					</template>
				</ui-box>
			</template>

			<template v-if="section === 'things'">Things To Do</template>

			<template v-if="section === 'gamification'">Gamification</template>

			<template v-if="section === 'invites'">Invites</template>

		</v-col>
	</v-row>
</template>


<script>
import { Place } from '../../../../Shared/helpers';

export default {
	name: "ViewPass",
	props: {
		partner: {
			type: Object,
			default: () => ({})
		},
		pass: {
			type: Object,
			default: () => ({})
		},
		places: {
			type: Array,
			default: () => []
		},
		section: {
			type: String,
			default: 'index'
		}
	},
	data() {
		return {
			localPlaces: []
		}
	},
	mounted() {
		this.places.forEach(place => this.localPlaces.push(new Place(place)));
	},
	computed: {
		defaultMedia() {
			return [
				{
					cropperSettings: {
						limitAR: "2:1",
						x: 0,
						y: 0
					},
					id: new Date().getTime(),
					location: "Header",
					minDimensions: "640x320",
					name: "Header",
					url: "https://placehold.co/640x320"
				}
			];
		},
		placesHeaders() {
			return [
				{
					align: 'start',
					mandatory: true,
					text: 'Image',
					value: 'media',
					width: '1%'
				},
				{
					align: 'start',
					mandatory: true,
					text: 'Name/Address',
					value: 'name'
				}
			];
		}
	}
}
</script>

<style lang="scss" scoped>
.v-data-table > .v-data-table__wrapper > table {
	& > tr {
		& > td {
			padding-bottom: 1rem;
			padding-top: 1rem;
			position: relative;
			vertical-align: top;
		}

		&:not(:last-of-type) > td {
			&::after {
				content: '';
				position: absolute;
				height: 1px;
				background: rgba(0, 0, 0, 0.04);
				bottom: 0;
			}

			&:first-child::after {
				left: 0;
				width: calc(100% - 1rem);
			}

			&:not(:first-child):not(:last-child)::after {
				left: 1rem;
				width: calc(100% - 2rem);
			}

			&:nth-child(2):last-child::after {
				left: 1rem;
				width: calc(100% - 1rem);
			}

			&:last-child::after {
				right: 0;
				white-space: nowrap;
				width: 100%;
			}
		}
	}
}

.table-label {
	padding-right: 1rem;
	white-space: nowrap;
	width: 1%;
}

.table-info {
	border-left: solid 1px rgba(0, 0, 0, 0.08);
	padding-left: 1rem;
}
</style>
